/*
 * Desktop - Side_cart - Urgency  --  variant: Urgency Social Proof
 * Moonshot experiment id: 50958829   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-10-03
 * Audience: DESKTOP   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_sc_d_urgency
 */
MGExp.run('sc_d_urgency', { name: "Desktop - Side_cart - Urgency / Urgency Social Proof", platform: 'desktop', target: 'side_cart' }, function () {
  !(function () {
    let e = [],
      i = [];
    async function t(t, n, s, a, r) {
      let c = {
        multi_target_selectors: e,
        page_identifier_selector: "#mini-cart-modal",
        exclude_from_timeout: i,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(t, n, s, a, r, c);
    }
    i.push(
      ".msai-urgency-banner",
      "#mini-cart-items-list li.empty",
      "#mini-cart-items-list li:not(.empty)",
    );
    const n =
      ".msai-urgency-banner{background:#F8ECD5;color:#483927;font-family:'Inter','Segoe UI',Arial,sans-serif;font-size:14px;border-radius:10px;margin:12px 0 20px 0;padding:10px 16px;display:flex;align-items:center;box-shadow:0 1px 4px rgba(30,20,8,0.09)}";
    (t(
      [".bag-title", "#mini-cart-items-list li:not(.empty)"],
      ".msai-urgency-banner",
      function (e, i) {
        const [t, n] = i;
        (t.classList.add("msai-side-cart-urgency"),
          t.insertAdjacentHTML(
            "afterend",
            '\n          <div class="msai-urgency-banner">\n            <svg width="18" height="18" style="margin-right:10px;flex:0 0 auto;" fill="none" stroke="#E4C590" stroke-width="1.8" viewBox="0 0 24 24">\n              <path d="M12 3v3M12 18v3M21 12h-3M6 12H3M16.95 7.05l-2.12 2.12M7.05 16.95l-2.12-2.12M16.95 16.95l-2.12-2.12M7.05 7.05l2.12 2.12" stroke-linecap="round"/>\n              <circle cx="12" cy="12" r="4.2" stroke="#95764A" />\n            </svg>\n            <span>Interest in these pieces just spiked.</span>\n          </div>\n        ',
          ));
      },
      n,
    ),
      t(
        ["#mini-cart-items-list li.empty", ".msai-urgency-banner"],
        ".msai-side-cart-empty",
        function (e, i) {
          const [t, n] = i;
          (n.remove(), t.classList.add("msai-side-cart-empty"));
        },
        n,
      ));
  })();
});
